export default {
    en: {
        textHorsEcran: 'Information on '
    },
    fr: {
        textHorsEcran: 'Information sur '
    }
};
